// extracted by mini-css-extract-plugin
export default {"overlay":"gw-z","bodyOpen":"hw-z","content":"iw-z","header":"jw-z","close":"kw-z","closeNoHeading":"lw-z"};